/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { SupplierDto } from '../../models/supplier-dto';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

export interface GetSupplier$Params {
  supplierId: string;
}

export function getSupplier(
  http: HttpClient,
  rootUrl: string,
  params: GetSupplier$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<SupplierDto>> {
  const rb = new RequestBuilder(rootUrl, getSupplier.PATH, 'get');
  if (params) {
    rb.path('supplierId', params.supplierId, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SupplierDto>;
    }),
  );
}

getSupplier.PATH = '/service/v1/supplier/{supplierId}';
